var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_5268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27734 27.0007H37.4007L35.2858 10.0039L35.2321 10.053L25.1793 23.1301L21.3316 18.7362L16.2579 23.5659L12.1483 16.2434L1.27734 27.0007Z",
    fill: "#203D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7799 5.64353L38.0043 7.43143L37.7316 1.40342L31.8506 2.47146L33.8968 4.12051L32.4497 5.98744C30.6995 4.09649 28.5735 2.58787 26.2066 1.55719C23.8396 0.526511 21.2832 -0.0037488 18.6994 1.99491e-05C13.74 1.99491e-05 8.98375 1.95998 5.47693 5.44874C1.97011 8.93749 0 13.6693 0 18.6031L0 24.5649L12.1485 12.5431L16.2581 19.8655L21.3318 15.0359L25.1795 19.4383L34.0192 7.93981L35.7799 5.64353Z",
    fill: "#CCD8E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_5268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImg);
export default __webpack_public_path__ + "static/media/logo_img.650a2ab6d7c8ceff2ac525c41afefc39.svg";
export { ForwardRef as ReactComponent };